import styles from './ParentCommunicationCard.module.css';

const ParentCommunicationCard = ({
  icon,
  label,
  leftCount,
  rightCount,
  leftLabel,
  rightLabel,
  themeColorVar,
  onClick = () => {},
}) => {
  const themeColor = `var(${themeColorVar})`;

  return (
    <div className={styles.wrapper} onClick={onClick}>
      <div className={styles.left}>
        <div className={styles.icon} style={{ color: themeColor }}>
          {icon}
        </div>
        <div className={styles.label} style={{ color: themeColor }}>
          {label}
        </div>
      </div>

      <div
        className={styles.right}
        style={{
          borderColor: themeColor,
          boxShadow: `0 4px 10px rgba(from ${themeColorVar} r g b / 10%)`,
        }}
      >
        <div className={styles.row}>
          <div className={styles.countBlock}>
            <div className={styles.count} style={{ color: themeColor }}>
              {leftCount}
            </div>
            <div className={styles.labelText} style={{ color: themeColor }}>
              {leftLabel}
            </div>
          </div>
          <div className={styles.countBlock}>
            <div className={styles.count} style={{ color: themeColor }}>
              {rightCount}
            </div>
            <div className={styles.labelText} style={{ color: themeColor }}>
              {rightLabel}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParentCommunicationCard;
